import { Product, RootProductId } from "../models";
import useStaticData from "./useStaticData";

export default function useProduct(productId: RootProductId): Product {
	const { products } = useStaticData();
	const product = products.find((p) => p.id === productId);
	if (!product) throw new Error(`Product with id ${productId} not found`);
	return product;
}
